import iconBlack from './reach_icon_rgb_black.svg';
import iconWhite from './reach_icon_rgb_white.svg';
import iconRegular from './reach_icon_rgb_purple.svg';
import logoBlack from './reach_logo_rgb_black.svg';
import logoWhite from './reach_logo_rgb_white.svg';
import logoRegular from './reach_logo_rgb_purple.svg';
import styles from './reach.module.css';
import { Theme, extendTheme } from '../theme-base';
import BanzaiTheme from '../banzai/banzai';

const ReachTheme: Theme = extendTheme(BanzaiTheme, {
  id: 'reach',
  email: {
    address: 'reach@banzai.io',
    senderName: 'Banzai Reach',
  },
  primaryColor: {
    hex: '#4643b5',
    rgb: [70, 67, 181],
    hsl: [242, 46, 49],
  },
  publicImages: {
    iconBlack:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/reach_icon_rgb_black.png',
    iconRegular:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/reach_icon_rgb_purple.png',
    iconWhite:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/reach_icon_rgb_white.png',
    logoBlack:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/reach_logo_rgb_black.png',
    logoRegular:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/reach_logo_rgb_purple.png',
    logoWhite:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/reach_logo_rgb_white.png',
  },
  iconBlack,
  iconWhite,
  iconRegular,
  iconAlt: 'Reach icon',
  logoBlack,
  logoWhite,
  logoRegular,
  logoAlt: 'Reach logo',
  styles,
  productName: 'Reach',
  login: {
    title: 'Login to win',
    subTitle: `You're just one step away from super-charging your marketing team`,
    quote: {
      text: `We’ve seen an impact from partnering with Banzai to generate leads at every stage of the funnel. We’ve had the opportunity to reach in-depth into an organization to be able to set meetings that we otherwise would never have been able to set.`,
      author: 'Lenny Eskin',
      role: 'Director of Demand Generation, ThoughtSpot',
    },
  },
});

export default ReachTheme;
